import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import { Icon } from "antd";
import throttle from 'lodash/throttle';
import classnames from 'classnames'
import styles from './imgPreview.module.less'
import { v4 as uuidv4 } from 'uuid';
import FileSaver from 'file-saver';
import download from 'image-downloader';


let ImageInfo = {};
let Zoom = 1.0;
let InitZoom = 1.0;
export default class ImgPreview extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            test: false,
            divRect: null,
            imageUrl: props.src,
            imageIsLoad: false,
            translateX: 0,
            translateY: 0,
            rotate: 0,
        }
        this.imageIsMoving = false;
        this.lastX = null;
        this.lastY = null;
        this.handleMouseMove = throttle(this.handleMouseMove, 30);
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
    }
    componentWillMount() {
        this.loadImage(this.props.src);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.props.visible !== prevProps.visible || prevProps.src !== this.props.src) && this.props.visible) {
            this.loadImage(this.props.src);
        }
    }

    loadImage = (imagePath) => {
        if (imagePath && imagePath.length > 0) {
            this.setState({
                test: false,
                divRect: null,
                imageIsLoad: false,
                translateX: 0,
                translateY: 0,
                rotate: 0,
            });
            ImageInfo = new Image;
            ImageInfo.src = imagePath;
            ImageInfo.onload = () => {
                this.setState({
                    imageIsLoad: true,
                    imageUrl: imagePath,
                    divRect: null,
                });
            };
        }
    }
    get isRotate() {
        return this.state.rotate == 90 || this.state.rotate == 270;
    }
    get imageWidth() {
        return (this.isRotate ? ImageInfo.height : ImageInfo.width) * Zoom;
    }
    get imageHeight() {
        return (this.isRotate ? ImageInfo.width : ImageInfo.height) * Zoom;
    }

    handleScroll = (e) => {
        const { imageIsLoad, translateX, translateY } = this.state;
        if (imageIsLoad) {
            let rect = e.currentTarget.getBoundingClientRect();
            let scaleWidth = (e.clientX - rect.left) / rect.width;
            let scaleHeight = (e.clientY - rect.top) / rect.height;
            this.zoomImage(e.nativeEvent.wheelDelta > 0, scaleWidth, scaleHeight);
        }
    }

    zoomImage = (isZoom, scaleWidth, scaleHeight) => {
        const { imageIsLoad, translateX, translateY } = this.state;
        if (imageIsLoad) {
            let lastWidth = this.imageWidth;
            let lastHeight = this.imageHeight;
            if (isZoom) {
                if (this.imageWidth * 1.3 < 33554400/*Chrome浏览器最大滚动上限*/) {
                    Zoom *= 1.3;
                }
            } else {
                Zoom /= 1.3;
            }
            if (Zoom <= InitZoom) {
                this.setImageWidth()
            } else {

                if (!scaleWidth)
                    scaleWidth = 0.5;
                if (!scaleHeight)
                    scaleHeight = 0.5;

                let nowWidth = (this.imageWidth - lastWidth) * scaleWidth;
                let nowHeight = (this.imageHeight - lastHeight) * scaleHeight;
                this.state.translateX = translateX - nowWidth;
                this.state.translateY = translateY - nowHeight;
            }
            this.test();
            this.setState({ test: false })
        }
    }

    setImageWidth = () => {
        const { imageIsLoad, divRect } = this.state;
        let imageWidth = this.isRotate ? ImageInfo.height : ImageInfo.width;
        let imageHeight = this.isRotate ? ImageInfo.width : ImageInfo.height;
        if (imageIsLoad && divRect.width > 0 && divRect.height > 0) {
            if (divRect.width / divRect.height > imageWidth / imageHeight) {
                Zoom = divRect.height / imageHeight;
            }
            else {
                Zoom = divRect.width / imageWidth;
            }
            Zoom *= 0.8;
            InitZoom = Zoom;
            this.test();
            this.setState({ test: false })
        }
    }


    onMouseLeave(e) {
        this.imageIsMoving = false;
    }

    onMouseDown(e) {
        this.imageIsMoving = true;
    }

    onMouseUp() {
        this.imageIsMoving = false;
        this.lastX = null;
        this.lastY = null;
    }

    onMouseMove(e) {
        e.persist();
        e.stopPropagation();
        this.handleMouseMove(e);
    }

    handleMouseMove = (e) => {
        if (this.imageIsMoving) {
            if (this.lastX && this.lastY) {
                let dx = e.clientX - this.lastX;
                let dy = e.clientY - this.lastY;
                this.state.translateX = this.state.translateX + dx;
                this.state.translateY = this.state.translateY + dy;
                this.test();
                this.setState({ test: false })
            }
            this.lastX = e.clientX;
            this.lastY = e.clientY;
        }
    }

    test = () => {
        const { divRect, translateX, translateY } = this.state;
        let x = translateX;
        let y = translateY;
        if (this.imageWidth > divRect.width && this.imageHeight > divRect.height) {
            if (translateX > 0)
                x = 0;
            if (translateY > 0)
                y = 0;
            if (translateX + this.imageWidth < divRect.width)
                x = divRect.width - this.imageWidth;
            if (translateY + this.imageHeight < divRect.height)
                y = divRect.height - this.imageHeight;
            this.setState({
                translateX: x,
                translateY: y,
            })
        } else if (divRect.width > this.imageWidth && divRect.height > this.imageHeight) {
            this.setState({
                translateX: (divRect.width - this.imageWidth) / 2,
                translateY: (divRect.height - this.imageHeight) / 2,
            })
        }
        else if (divRect.width < this.imageWidth || divRect.height < this.imageHeight) {
            if (divRect.height < this.imageHeight) {
                let imageX = divRect.left + translateX;
                let imageY = divRect.top + translateY;
                if (translateY > 0) {
                    y = 0;
                }
                else if ((imageY + this.imageHeight) < (divRect.top + divRect.height)) {
                    y = divRect.height - this.imageHeight;
                }
                this.setState({
                    translateX: (divRect.width - this.imageWidth) / 2,
                    translateY: y,
                })
            } else {
                let imageX = divRect.left + translateX;
                let imageY = divRect.top + translateY;
                if (translateX > 0) {
                    x = 0;
                }
                else if ((imageX + this.imageWidth) < (divRect.left + divRect.width)) {
                    x = divRect.width - this.imageWidth;
                }
                this.setState({
                    translateX: x,
                    translateY: (divRect.height - this.imageHeight) / 2,
                })
            }
        }
    }
    closePreview = () => {
        this.setState({
            imageUrl: "",
            imageIsLoad: false,
        })
    }

    downloadImage = () => {
        const { imageUrl } = this.state;
        const { fileName } = this.props;
        let duwnloadFileName = (fileName && fileName.length > 0) ? fileName : uuidv4() + `.jpg`;
        FileSaver.saveAs(imageUrl, duwnloadFileName);
    }

    render() {
        const { imageUrl, imageIsLoad, } = this.state;
        const { onLeft, onRight, onClose, visible } = this.props;

        let translateX = this.isRotate ? this.state.translateX + (this.imageWidth - this.imageHeight) / 2 : this.state.translateX;
        let translateY = this.isRotate ? this.state.translateY - (this.imageWidth - this.imageHeight) / 2 : this.state.translateY;

        let main = !visible ? `` : (
            <div className={styles.mainDiv} >
                <div className={styles.imageDiv} >
                    <div
                        className={styles.imageShow}
                        draggable={`false`}
                        ref={thisDiv => {
                            if (thisDiv && imageIsLoad && this.state.divRect === null) {
                                this.state.divRect = thisDiv.getBoundingClientRect();
                                this.setImageWidth();
                            }
                        }}
                    >
                        <div
                            className={classnames(styles.imageDiv, styles.image)}
                            onWheel={e => this.handleScroll(e)}
                            onMouseDown={e => this.onMouseDown(e)}
                            onMouseUp={e => this.onMouseUp(e)}
                            onMouseMove={e => this.onMouseMove(e)}
                            onMouseLeave={e => this.onMouseLeave(e)}
                            draggable={`false`}
                            style={{
                                cursor: "move",
                                width: `${ImageInfo.width * Zoom}px`,
                                height: `${ImageInfo.height * Zoom}px`,
                                transform: `translateX(${translateX}px)translateY(${translateY}px)rotate(${this.state.rotate}deg)`,
                            }}
                        >
                            {imageIsLoad ? (<img
                                className={styles.image}
                                src={imageUrl}
                                draggable={`false`}
                                style={{
                                    position: `absolute`,
                                    zIndex: `-1`,
                                    width: `100%`,
                                    height: `100%`,
                                }}
                            />) : ""}
                        </div>
                    </div>
                </div>

                <div className={styles.buttons}>
                    <div className={styles.buttonDiv}>
                        {onLeft ?
                            <div onClick={() => { onLeft() }} className={styles.button}>
                                <Icon type="left" className={styles.icon} />
                            </div>
                            : ``
                        }
                        <div onClick={() => { this.zoomImage(true) }} className={styles.button}>
                            <Icon type="zoom-in" className={styles.icon} />
                        </div>
                        <div onClick={() => { this.zoomImage(false) }} className={styles.button}>
                            <Icon type="zoom-out" className={styles.icon} />
                        </div>
                        <div onClick={() => {
                            this.state.rotate += 90;
                            if (this.state.rotate > 270) {
                                this.state.rotate = 0;
                            }
                            this.setImageWidth();
                        }} className={styles.button}>
                            <Icon type="redo" className={styles.icon} />
                        </div>
                        <div onClick={() => { this.downloadImage(); }} className={styles.button}>
                            <Icon type="download" className={styles.icon} />
                        </div>
                        {onRight ?
                            <div onClick={() => { onRight() }} className={styles.button}>
                                <Icon type="right" className={styles.icon} />
                            </div>
                            : ``
                        }
                    </div>
                </div>
                <div onClick={() => { onClose ? onClose() : ""; this.closePreview(); }} className={styles.closeButton}>
                    <Icon type="close" className={styles.icon} />
                </div>
            </div >
        )
        return ReactDOM.createPortal(main, this.node,);
    }

}
